const options = {
  enableHighAccuracy: true,
  timeout: 10000, // 10 seconds
  maximumAge: 0,
};

function onSuccess(pos) {
  const crd = pos.coords;
  localStorage.latitude = crd.latitude;
  localStorage.longitude = crd.longitude;
}

export default function getUserLocation(retry) {
  navigator.permissions
    .query({ name: 'geolocation' })
    .then(permissionStatus => {
      if (
        permissionStatus.state === 'granted' ||
        permissionStatus.state === 'prompt'
      ) {
        navigator.geolocation.getCurrentPosition(
          pos => onSuccess(pos),
          err => {
            console.error(`ERROR(${err.code}): ${err.message}`);
            if (retry) {
              setTimeout(() => getUserLocation(retry), 10000);
            }
          },
          options,
        );
      } else if (permissionStatus.state === 'denied') {
        alert(
          'Location access denied. Please enable it in your browser settings.',
        );
      }
    });
}

getUserLocation(window.location.hostname !== 'localhost');
